import React from 'react';
import { WaystarResponse } from '../types/x12';
import X12_271_Response_Display from './X12_271_Response_Display';
import X12_997_Response_Display from './X12_997_Response_Display';
import { Textarea } from '@roger/ui-components';

interface X12_Response_DisplayProps {
  waystarResponse: WaystarResponse;
}

const X12_Response_Display: React.FC<X12_Response_DisplayProps> = ({
  waystarResponse,
}) => {
  if (!waystarResponse) return null;

  switch (waystarResponse.message_type) {
    case '271':
      return <X12_271_Response_Display waystarResponse={waystarResponse} />;
    case '997':
      return <X12_997_Response_Display waystarResponse={waystarResponse} />;
    default:
      return (
        <div>
          <label className='block text-sm font-medium mb-2'>
            Unknown X12 Response Type
          </label>
          <Textarea
            value={JSON.stringify(waystarResponse, null, 2)}
            readOnly
            className='font-mono text-xs h-32'
            placeholder='Raw response will appear here...'
          />
        </div>
      );
  }
};

export default X12_Response_Display;
